import React from 'react';
import './sliderMaster.css';
import profile from '../../images/splash/user.png';
import { useState,useEffect } from 'react';
import axios from 'axios';
import { var_api,image_api } from '../constant';
import Swal from 'sweetalert2';
import { useHistory } from 'react-router-dom';
import Select from 'react-select';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import Spinner from 'react-bootstrap/Spinner';
import Layout from '../NewHeader/Layout';
import cimage from '../../images/bannerbackground.jpg';
import cimg1 from '../../images/Logistic.jpg'
import Pagination from 'react-js-pagination';
import Loader from '../Loader/Loader';


const SliderMaster = () => {
  const history = useHistory();
  const [show, setShow]  = useState(false);
  const [tables, setTables] = useState([]);
  const [shops, setShops] = useState([]);
  const [selectedShop, setSelectedShop] = useState(null);
  const [ searchQuery,setSearchQuery] = useState('');
  const [selectedItemCode, setSelectedItemCode] = useState(null);
  const [ isEdit,setIsEdit ] = useState(false);
  
  const [ isCreate,setCreate ] = useState(false);

  const [ loading, setLoading ] = useState(false);
  const [ isLoading, setIsLoading ] = useState(false);
  const [ postloading,setPostLoading ] = useState(false);
  const ItemCodeOptions = [

    { value: 'Chef', label: 'Chef' },
    { value: 'Captain', label: 'Captain' },
    { value: 'Waiter', label: 'Waiter' },
    // Add more options as needed
  ];
  
  const [DeleteId, setEmployeeD] = useState({});
  const [formData, setFormData] = useState({
    description: '',
    image: null,
    shop_id: '' 
});
const [updateformData, setUpdateFormData] = useState({
  description: '',
    image: null,
    shop_id: '',
    id:null
});

console.log(formData)
const [currentPage, setCurrentPage] = useState(1);
const [itemsPerPage] = useState(10); // Number of items per page
const [searchTerm, setSearchTerm] = useState('');

// Filtering tables based on search term
const filteredTables = tables.filter((item) => {
  return (
  item.description.toLowerCase().includes(searchTerm.toLowerCase()) 
  );
});

// Pagination logic
const indexOfLastItem = currentPage * itemsPerPage;
const indexOfFirstItem = indexOfLastItem - itemsPerPage;
const currentItems = filteredTables.slice(indexOfFirstItem, indexOfLastItem);
const totalItems = filteredTables.length;

const handleSearchInput = (event) => {
  setSearchTerm(event.target.value);
  setCurrentPage(1); // Reset to the first page when search changes
};

const handlePageChange = (pageNumber) => {
  setCurrentPage(pageNumber);
};


  


    useEffect(() => {
        fetchTables();
        // fetchShops();
      }, []);


      const fetchTables = async (id) => {
        const token = localStorage.getItem('Token');
        setLoading(true);
        console.log(id)
        const shopId =localStorage.getItem('ShopId');
        try {
           const shop = localStorage.getItem('ShopId')
           const response = await axios.get(`${var_api}slider-master/get/${shopId}`,{
            headers:{
              Authorization:`${token}`
            }
           });
           setLoading(false);
           console.log("response",response)
          const user =response.data;
          setTables(user.data);
          
        } catch (error) {
          setLoading(false);
          if (error.response && error.response.status === 401) {
            localStorage.removeItem('Token'); // Clear the invalid token
            history.push('/')// Redirect to the Sign-In page
          } else {
            console.error("Error updating data:", error);
          }
          setTables([])
        }
      };
      

      const fetchShops = async () => {
        try {
           const shop = localStorage.getItem('userId')
           const response = await axios.get(`${var_api}/api/shop/data/${shop}`);
           console.log("response",response)
          const user =response.data;
          setShops(user);
          setFormData(prevState => ({
            ...prevState,
            shops: user.map(shop => ({ shop_id: shop.id, shop_name: shop.shop_name, is_active: 0 }))
          }));
        } catch (error) {
          console.log(error);
        }
      };

      
      



//handle image change post
    const handleImageChange= (e) => {
        const file = e.target.files[0];
        console.log("files",file);
         // Check the file extension or MIME type
          const validExtensions = ['image/png', 'image/jpeg', 'image/jpg'];
          if (file && validExtensions.includes(file.type)) {
            // If the file is valid, set the form data with the image
            setFormData({ ...formData, image: file });
          } else {
            // If the file is not valid, show an error message
            Swal.fire({
              icon: "error",
              text: "Please upload a valid image file (PNG, JPEG, JPG).",
              confirmButtonColor: "#007500",
            });
            // Optionally reset the input field
            e.target.value = '';
          }
      };

  
      //handle image change put
      const handleImageChanges= (e) => {
        const file = e.target.files[0];
        console.log("files",file);
         // Check the file extension or MIME type
         const validExtensions = ['image/png', 'image/jpeg', 'image/jpg'];
         if (file && validExtensions.includes(file.type)) {
           // If the file is valid, set the form data with the image
           setUpdateFormData({ ...updateformData, image: file });
         } else {
           // If the file is not valid, show an error message
           Swal.fire({
             icon: "error",
             text: "Please upload a valid image file (PNG, JPEG, JPG).",
             confirmButtonColor: "#007500",
           });
           // Optionally reset the input field
           e.target.value = '';
         }
      };


//handle text field change
const handleInputChange = (e) => {
  const { name, value } = e.target;
  setFormData({
    ...formData,
    [name]: value,
  });
};



const handleInputChanges = (event) => {
  const { name, value } = event.target;
  setUpdateFormData({
    ...updateformData,
    [name]: value
  });
};




  // Function to capitalize the first letter of a string
  const capitalize = (str) => {
    return str.charAt(0).toUpperCase() + str.slice(1);
   };
  

      //post the form data
    const Submit = async (e) => {
      setIsLoading(false);
      e.preventDefault();

      try {

        const shop_id=localStorage.getItem('ShopId');
        const token=localStorage.getItem('Token');

        const formDataToSend = new FormData();
        // Append all form fields to the FormData object
        formDataToSend.append('description', formData.description);
        formDataToSend.append('image', formData.image);
        formDataToSend.append('shop_id', shop_id);
        
        setPostLoading(true); // Start loading
        const response = await axios.post(`${var_api}slider-master/post`, formDataToSend, {
            headers: {
                'Content-Type': 'multipart/form-data', // Set content type to multipart/form-data
                Authorization:`${token}`
            }
        });
        const result = response.data;
        console.log("rrrr",result);
          setCreate(false);
          fetchTables();
          Swal.fire({
            icon:"success",
            text:'Slider Image Created Successfully',
            confirmButtonColor:"#007500"
          })

          setFormData({ description: '', image: null }); // Reset form data
        // Handle successful response (e.g., show a success message to the user)
      } catch (error) {
        // Handle request failure
        Swal.fire({
          icon:"error",
          text: error.response.data.error,
          confirmButtonColor:"#007500"
        })
        if (error.response && error.response.status === 401) {
          localStorage.removeItem('Token'); // Clear the invalid token
          history.push('/')// Redirect to the Sign-In page
        } else {
          console.error("Error updating data:", error);
        }
      } finally {
        setIsLoading(false); // End loading
      }
    };



      

     //delete method for remove UOM
     const handleDeleteEmployeee = (id) => {
      setEmployeeD({id});
      setShow(true);
    };


    //delete the employeee
    const handleDelete = () => {
      const token=localStorage.getItem('Token');
      axios.delete(`${var_api}slider-master/delete/${DeleteId.id}`,{
        headers:{
          Authorization:`${token}`
        }
      }
      )
        .then((response) => {
          if (response.status === 200) {
            fetchTables(); // Refresh the employee list
            setShow(false);
            Swal.fire("Success", "Slider Image removed successfully!", "success");
          } else if (response.status === 404) {
            console.error("Slider not found");
          }
        })
        .catch((error) => {
          if (error.response && error.response.status === 401) {
            localStorage.removeItem('Token'); // Clear the invalid token
            history.push('/')// Redirect to the Sign-In page
          } else {
            console.error("Error updating data:", error);
          }
          Swal.fire("Error", `${error.response.data.message}`, "error");
        });
      };


  
    const handleCreateEmployee = () =>{
      setCreate(true);
      setFormData({});
    }






//update method for employee
//post method for updating the food
const handleUpdateSubmit = async (e) => {
  e.preventDefault();  
  console.log("updateformData",updateformData);
  setIsLoading(true);
  const token=localStorage.getItem('Token');
  

  const formDataToSend = new FormData();
  formDataToSend.append('description', updateformData.description);
  formDataToSend.append('image', updateformData.image);
  formDataToSend.append('shop_id', updateformData.shop_id);
  
  

   try {
    const response = await fetch(`${var_api}slider-master/put/${updateformData.id}`, {
      method: 'PUT',
    body: formDataToSend,
    headers:{
      Authorization:`${token}`
    }
  }
);
    if(response.status == 200){
      fetchTables();
      setIsEdit(false);
      Swal.fire({
        title: 'Success',
        text: 'Slider Updated Successfully.',
        icon: 'success',
        confirmButtonColor: '#007500', // Set the custom color for the Confirm button
      });
      
      const data = await response.json();
      console.log('Slider Updated successful!',data);
   
    }else {
      console.error('Failed to Update Food:', response.statusText);
      // Handle error, e.g., show an error message to the user
      Swal.fire({
        title: 'error',
        text: 'Failed to Update Food...Please Try Again!',
        icon: 'error',
        confirmButtonColor: '#007500', // Set the custom color for the Confirm button
      });
    }
    
    // Handle success scenario as needed
  } catch (error) {
    if (error.response && error.response.status === 401) {
      localStorage.removeItem('Token'); // Clear the invalid token
      history.push('/')// Redirect to the Sign-In page
    } else {
      console.error("Error updating data:", error);
    }
    } finally {
      setIsLoading(false);
    }
  };

  const handleToggle = (isChecked, item) => {
    // Create FormData
    const formData = new FormData();
    formData.append("shop_id", item.shop_id);
    formData.append("name", item.name);
    formData.append("image", item.image); // If `item.image` is a file, this works; otherwise, ensure it's the correct type
    formData.append("is_active", isChecked ? 1 : 0);
  
    const token = localStorage.getItem("Token");
  
    axios
      .put(`${var_api}background_image_master/put/${item.id}`, formData, {
        headers: {
          Authorization: `${token}`,
          "Content-Type": "multipart/form-data", // FormData requires this Content-Type
        },
      })
      .then((response) => {
        if (response.status === 200) {
          Swal.fire("Success", "Status updated successfully!", "success");
          fetchTables();
        } else {
          Swal.fire("Error", "Failed to update  status!", "error");
        }
      })
      .catch((error) => {
        if (error.response && error.response.status === 401) {
          localStorage.removeItem('Token'); // Clear the invalid token
          history.push('/')// Redirect to the Sign-In page
        } else {
          console.error("Error updating data:", error);
        }
        Swal.fire("Error", `${error.response?.data?.error || "Unexpected error occurred"}`, "error");
      });
  };

  //clicking edit icon save existing item
  const handleEdit = (item) => {
    setUpdateFormData({
      description: item.description,
      id: item.id,
      shop_id: item.shop_id,
      image: item.image,
     });
    setIsEdit(true); // Open the edit modal
  };




    return(
      <>         <Layout>

{isLoading && <Loader />}

            <div class="splitcc">
          
      <div style={{border:"none",padding:"15px",width:"105%",minHeight:"630px",margin:"auto",borderRadius:"10px",backgroundColor:"white",boxShadow:" rgba(17, 17, 26, 0.1) 0px 8px 24px, rgba(17, 17, 26, 0.1) 0px 16px 56px, rgba(17, 17, 26, 0.1) 0px 24px 80px"}}>
    
      <Button variant='dark'className='mb-4' onClick={handleCreateEmployee}   style={{fontSize:"14px",float:"right",borderRadius:"10px", marginLeft:"10px"}}>Create Slider</Button>{' '}
      
      <div>

       <div class="row">
         <div class="col">
<h4 className='ushe'> SLIDER MASTER</h4>
         </div>
         <div class="col">
         <input class="form-control" type="Search" placeholder="Search" id="example-search-input" 
    style={{width:"230px",borderRadius:"10px",border:"1px solid black",float:"right"}} onChange={handleSearchInput}/>
         </div>
        
       </div>
    <br/>
      <div className="table-container" style={{ maxHeight:"540px", overflowX: 'auto', overflowY: 'scroll' }}>
     <table class="table table-hover small-first-col" style={{border:"none",borderColor:"grey",width:"90%",margin:"auto"}}>
  <thead>
    <tr style={{fontWeight:"bolder"}}>
      <th style={{textTransform:"capitalize",textAlign:"left"}} scope="col">S.No</th>
      <th style={{textTransform:"capitalize",textAlign:"left"}} scope="col">Image</th>
      <th style={{textTransform:"capitalize",textAlign:"left"}} scope="col">Description</th>
      <th style={{textTransform:"capitalize",textAlign:"left"}} scope="col">Action</th>
    </tr>
  </thead>
  {loading ? (
        <div className="loader-containeru">
      	  <div className="spinneru"></div>
        </div>
  ) : 
<tbody class="body-half-screen">
{currentItems && currentItems.length > 0 ? (
currentItems.map((item, index) => (
 <tr style={{padding:"7px"}}  key={index}>
   <th scope="row" style={{textTransform:"capitalize",textAlign:"left"}}>{index+1}</th>
   <td style={{textTransform:"capitalize",textAlign:"left"}}> <img
            src={`${image_api}/${item.image}`}
            alt="profile"
            style={{ width: '75px', height: '65px', objectFit: 'cover' }}
          />
          </td>
  
          <td style={{textTransform:"capitalize",textAlign:"left"}}>{item.description}</td>
   <td style={{textAlign:"left"}}>
   <i class="bi bi-pencil-square"    onClick={() => handleEdit(item)}  style={{fontSize:"20px",color:"rgb(9, 97, 9)"}}></i>{' '}
   <i class="bi bi-trash" onClick={() => handleDeleteEmployeee(item.id)} style={{fontSize:"21px",color:"rgb(175, 2, 2)"}}></i>
   </td>
  
 </tr>
   ))
  ) : (
    <tr>
      <td
        colSpan="12"
        style={{
          textAlign: "center",
          color: "grey",
          borderColor: "black",
        }}
      >
        No Data Available
      </td>
    </tr>
  )}
</tbody>
}
</table>
<Pagination
        activePage={currentPage}
        itemsCountPerPage={itemsPerPage}
        totalItemsCount={totalItems}
        pageRangeDisplayed={5}
        onChange={handlePageChange}
        itemClass="page-item"
        linkClass="page-link"
        innerClass="pagination justify-content-end"
        activeClass="active-pagination"
      />
      </div>
      

</div>
        </div>
      
      </div>

      <Modal
        show={show}
        onHide={()=>setShow(false)}
        backdrop="static"
        keyboard={false}
        size="md" // Set size to large
      >
        <Modal.Header style={{padding:"3px", backgroundColor:"green"}}>
          <Modal.Title style={{ fontSize:"20px"}}></Modal.Title>
        </Modal.Header>
        <Modal.Body>

         <div style={{padding:"20px"}}>
         {/* <h4 style={{fontFamily:"monospace",fontWeight:"bolder",textAlign:"center"}}>CONFIRM !</h4> */}
          <h6 className='text-dark' style={{textAlign:"center",fontWeight:"bolder"}}>Are You Sure want to Delete this Slider Image 
          <span style={{color:"red",textTransform:"uppercase"}}> </span> ?</h6> 
         </div>
         {' '} 
          <Button variant="danger" style={{float:"right"}} onClick={()=>setShow(false)}>
            Close
          </Button>{' '} 
          <Button variant="success" style={{float:"right",marginRight:"5px"}} onClick={handleDelete}>
            Confirm
          </Button>
        </Modal.Body>
       
      </Modal>

      <Modal
        show={isEdit}
        onHide={()=>setIsEdit(false)}
        backdrop="static"
        keyboard={false}
        size="lg"
      >
        <Modal.Header closeButton>
          <Modal.Title> Update Slider Image </Modal.Title>
        </Modal.Header>
        <Modal.Body>
        <form  className="py-2" onSubmit={handleUpdateSubmit}>
          <div class="row">
          <div class="col">
               <label for="input1" style={{color:"green",fontFamily:"serif",fontWeight:"bolder"}}>Description</label>
               <input type="text" class="form-control" id="floatingInput" placeholder="Description" name='description' value={updateformData.description} onChange={handleInputChanges}  style={{borderRadius:"10px",height:"40px"}} required/>
               </div>
               <div class="col">
            <label for="input5" style={{color:"green",fontFamily:"serif",fontWeight:"bolder"}}>Slider Image{" "}</label>
            <input type="file" class="form-control" id="formFile" onChange={handleImageChanges} name='image' style={{borderRadius:"10px",height:"40px"}} />
            </div>
          </div>
          <div class="row">
          
            <div class="col" style={{zIndex:"2"}}>
   
            </div>
          
          </div>
         
         <br/>
          <button className="btn btn-success" style={{float:"right",margin:"5px",borderRadius:"10px"}}>Update</button>
          </form>
          <button className="btn btn-danger" onClick={()=>setIsEdit(false)} style={{borderRadius:"10px",float:"right",marginTop:"-1px"}}>Cancel</button>
        </Modal.Body>
      </Modal> 

      <Modal
        show={isCreate}
        onHide={()=>setCreate(false)}
        backdrop="static"
        keyboard={false}
        size="lg"
      >
        <Modal.Header closeButton>
          <Modal.Title> Create Slider Image </Modal.Title>
        </Modal.Header>
        <Modal.Body>
        <form  className="py-2" onSubmit={Submit}>
          <div class="row">
            <div class="col">
               <label for="input1" style={{color:"green",fontFamily:"serif",fontWeight:"bolder"}}>Description</label>
               <input type="text" class="form-control" id="floatingInput" placeholder="Description" name='description' value={formData.description} onChange={handleInputChange}  style={{borderRadius:"10px",height:"40px"}} required/>
               </div>
               <div class="col">
            <label for="input5" style={{color:"green",fontFamily:"serif",fontWeight:"bolder"}}>Slider Image{" "}</label>
            <input type="file" class="form-control" id="formFile" onChange={handleImageChange} name='image'  style={{borderRadius:"10px",height:"40px"}} required/>
            </div>
          </div>
         
         <br/>
         <div class="text-center">
          {postloading ? (
          <Spinner
            as="span"
            animation="border"
            size="sm"
            role="status"
            aria-hidden="true"
           
          />
        ) : (
          <button className='btn btn-success' style={{borderRadius:"10px",float:"right",marginTop:"6px"}} disabled={postloading}>Create</button>
        )}
        </div>           </form>
          <button className="btn btn-danger" onClick={()=> setFormData({ description: '', image: null })} style={{borderRadius:"10px",float:"right",marginRight:"5px"}}>Reset</button>
        </Modal.Body>
      </Modal> 


            {/* </div> */}
       </Layout></>

        
    )
}

export default SliderMaster;